import KardiaRxEcgTable from './KardiaRxEcgTable';

export default KardiaRxEcgTable;



// WEBPACK FOOTER //
// ./src/views/containers/KardiaRxEcgTable/index.js